import React, { useState, useEffect } from 'react';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import { Field } from '../../../ui/Field';
import Select from 'react-select';
import CreatePage from '../../../composents/CreatePage';

const title = 'Cities';
const headers = {
	icon: 'feather icon-plus',
	title: title,
	description: 'creation of new city',
	breadcrumbs: [
		{
			title: title,
			link: '/hydrodrip/cities',
		},
	],
};

export default function CreateCity() {
	const [loader, setLoader] = useState(false),
		[errors, setErrors] = useState({}),
		[country, setCountry] = useState([]),
		[countries, setContries] = useState();

	async function onGet() {
		let cus = await resources.country
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (cus.status === 200) {
			let a = [];
			cus.data.docs.forEach((el) => {
				a.push({
					value: el.id,
					label: el.name,
				});
			});
			setContries(a);
		}
	}

	useEffect(() => {
		onGet();
	}, []);

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		object.country = country;
		setLoader(true);
		setErrors({});
		let res = await resources.city
			.create(object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/hydrodrip/cities');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	return (
		<CreatePage show_error={errors['not_autorized']} headers={headers}>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Country{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={(e) => {
											if (e) setCountry(e?.value);
										}}
										options={countries}
										required
										isSearchable
										isClearable
										className={
											errors['country']
												? ' is-invalid'
												: ''
										}
									/>
									{errors['country'] && (
										<div className="invalid-feedback">
											{errors['country']}
										</div>
									)}
								</div>

								<Field
									name="name"
									className="mb-3"
									error={errors['name']}
									required
								>
									City name
								</Field>

								<Field
									name="code_1"
									type="number"
									className="mb-3"
									error={errors['code_1']}
									required
								>
									City code 1
								</Field>

								<Field
									name="code_2"
									className="mb-3"
									error={errors['code_2']}
									required
								>
									City code 2
								</Field>

								<Field
									name="description"
									type="textarea"
									error={errors['description']}
									className="mb-3"
								>
									Description
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary"
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</CreatePage>
	);
}
